/* 曹操（字孟德） */
import { L } from '../../core/kit.ts';
import { defineHero, U, P, S } from '../define.ts';

export default defineHero({
  id: 'caocao', name: '曹操', sub: '字孟德', faction: 'wei', role: '指揮', weapon: 'sword',
  look: { ranged: true,
    weaponName: '倚天劍', robe: true, skin: '#efcaa0', hair: '#161419', beard: 'goatee', eye: 'narrow', head: 'crown', fx: '#8fbaff',
    c: { armor: '#2a3558', sleeve: '#26335f', cloth: '#26335f', trim: '#d9b45c', pants: '#1d2238', boot: '#18181f', cape: '#8a1f2a', belt: '#141a2e', metal: '#e3e8ec', plume: '#d9b45c', pole: '#3a2a22' },
  },
  skills: [
    ['黑死爪', 'heal', '治療一名友軍 {300/400/500/600} 生命；若附近沒有受傷的友軍，則對敵人造成一半傷害。', { x: { k: 'nuke', heal: [300, 400, 500, 600], allyFirst: true, fx: 'heal' }, aim: U(480), cd: 22, mp: [100, 125, 150, 175], el: 'shadow' }],
    ['火焰直擊', 'fire', '烈焰直擊目標，造成 {85/145/190/250} 傷害。', { x: { k: 'nuke', dmg: [85, 145, 190, 250], fx: 'fire' }, aim: U(480), cd: 18 }],
    ['傳送', 'blink', '連同身邊的小兵一起傳送到遠處。冷卻 {60/50/40/30} 秒（依本作節奏縮短）。', { x: { k: 'blink', carry: 160 }, aim: P(1400, 0), cd: [60, 50, 40, 30], mp: [80, 70, 60, 50] }],
    ['亂世奸雄', 'command', '號令天下：1 秒後，全地圖每一名敵將（看不到的也算）受到 {200/290/380} 傷害。冷卻 {200/180/160} 秒。', { sig: 'global', gdmg: [200, 290, 380], aim: S(0), cd: [200, 180, 160], mp: [200, 250, 300], el: 'shadow', shout: '寧教我負天下人！' }],
  ],
  // 專屬招式（技能資料裡的 sig，取代該原型的一般動作）：(u, a, k, dt, cross)，this 是 World
  sigSkills: {
    // 亂世奸雄：全地圖敵將，先出預警再落下
    global(u, a, k, dt, cross) {
      const sk = a.sk, lvl = a.lvl;
      if (cross(0.3)) {
        const dmgG = L(sk.gdmg, lvl) * (1 + ((u.sp || 0) + (u.spAura || 0)) / 100);
        const foes = this.units.filter((t) => t.kind === 'hero' && this.hostile(u, t)); // 不看視野：迷霧裡的也打
        this.say(`${u.name}：「${sk.shout || '號令天下'}」全地圖敵將遭到打擊！`, 'big');
        foes.forEach((t) => {
          this.fx({ k: 'warn', x: t.x, y: t.y, r: 70, t: 1 });
          this.later(1, () => { if (!t.alive) return; this.damage(u, t, dmgG, { magic: true, spell: true }); this.fx({ k: 'thunder', x: t.x, y: t.y, col: '#b07cff' }); });
        });
      }
    },
  },
});
